import { render, staticRenderFns } from "./emergencyActionPlanDocuDetail.vue?vue&type=template&id=36781618"
import script from "./emergencyActionPlanDocuDetail.vue?vue&type=script&lang=js"
export * from "./emergencyActionPlanDocuDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36781618')) {
      api.createRecord('36781618', component.options)
    } else {
      api.reload('36781618', component.options)
    }
    module.hot.accept("./emergencyActionPlanDocuDetail.vue?vue&type=template&id=36781618", function () {
      api.rerender('36781618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/eap/emergencyActionPlanDocuDetail.vue"
export default component.exports